export { default } from "bullitttime-embermodelsgochips/serializers/activator";
